/* global CKEDITOR */
import $ from 'jquery';

// TODO: Get from Rails, since it is the main source.
const rtlLocales = ['ar'];

const reloadCkeditor = (input, locale, dir) => {
  if (typeof CKEDITOR !== 'undefined') {
    if (CKEDITOR.instances[input.id]) {
      CKEDITOR.instances[input.id].destroy();
    }
    CKEDITOR.replace(input.id, {
      ...input.dataset,
      contentsLangDirection: dir,
      contentsLanguage: locale,
    });
  }
};

/** Load ckeditors on startup */
$('[data-ckeditor]').each((_index, input) => {
  reloadCkeditor(
    input,
    input.dataset.contentsLanguage,
    input.dataset.contentsLangDirection,
  );
});

/**
 * Switch direction on inputs when the locale input changes.
 * In the HTML form, add 'data-locale-input' attribute to locale inputs and
 * 'data-refresh-dir' to any inputs which should update their direction based on
 * the locale.
 */
$('[data-locale-input]').on('change', event => {
  const locale = event.target.value;
  const dir = rtlLocales.includes(locale) ? 'rtl' : null;

  $('[data-refresh-dir]').each((_index, input) => {
    $(input).attr('dir', dir);
  });

  $('[data-ckeditor][data-refresh-dir]').each((_index, input) => {
    reloadCkeditor(input, locale, dir);
  });
});
